import Axios from './axios'

export default {
  createUser: (serviceAreaId, uuid) => {
    const axios = Axios.setup(serviceAreaId)

    return new Promise((resolve) => {
      const params = {
        uuid: uuid,
        serviceCode: 'JRE'
      }
      axios.put(`users/updateToken`, params)
        .then(payload => {
          resolve(payload.data.token)
        })
    })
  }
}
